import { useState } from 'react';
import { Stack } from '@mui/material';
import { VigoTypography } from 'src/@vigo/vigo-typography';
import { ImageOffOutline } from 'mdi-material-ui';

interface DashboardComponentOptionImageProps {
  image?: string;
  componentName?: string;
  description?: string;
}

const DashboardComponentOptionImage: React.FC<DashboardComponentOptionImageProps> = ({
  image = '',
  componentName = '',
  description = ''
}) => {
  const [imageLoaded, setImageLoaded] = useState<boolean>(true);

  return (
    <>
      {imageLoaded ? (
        <img
          src={image}
          alt={componentName}
          onError={() => {
            console.log('Image failed to load');
            setImageLoaded(false);
          }}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain'
          }}
        />
      ) : (
        <Stack
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            height: '100%'
          }}>
          <ImageOffOutline />
          <VigoTypography
            disableTranslation
            value={description}
            sx={{
              fontWeight: 'bold',
              color: '#666',
              textAlign: 'center',
              textTransform: 'capitalize'
            }}
          />
        </Stack>
      )}
    </>
  );
};

export default DashboardComponentOptionImage;
